import { render, staticRenderFns } from "./AnalisiRischiThEdit.vue?vue&type=template&id=7917fac6"
import script from "./AnalisiRischiThEdit.vue?vue&type=script&lang=js"
export * from "./AnalisiRischiThEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports